__turbopack_context__.v({
  "clickable": "CollectionStat-module__bEpURG__clickable",
  "icon": "CollectionStat-module__bEpURG__icon",
  "root": "CollectionStat-module__bEpURG__root",
  "skele": "CollectionStat-module__bEpURG__skele",
  "small": "CollectionStat-module__bEpURG__small",
});
